import $ from 'jquery';

const defaults = {
  autoplaySpeed: 3000,
  loop: '<div class="loop run"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 60"><circle class="progress" cx="30" cy="30" r="27" stroke-width="6" fill="none" stroke="white" stroke-dasharray="169.646" stroke-dashoffset="169.646"></circle><circle class="halo" cx="30" cy="30" r="27" stroke-width="2" fill="none" stroke="white"></circle></svg></div>',
};

export default class Loop {
  constructor($element, options) {
    this.$element = $element;
    this.settings = Object.assign({}, defaults, options);
    this.beforeChange = this.beforeChange.bind(this);
    this.afterChange = this.afterChange.bind(this);
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.$loop = this.addLoop();
    this.listen();
  }

  addLoop() {
    const $loop = $(this.settings.loop);
    $loop.appendTo(this.$element);
    $loop.find('.progress').css('animation-duration', `${this.settings.autoplaySpeed}ms`);
    return $loop;
  }

  beforeChange() {
    this.$loop.removeClass('run');
  }

  afterChange() {
    this.$loop.addClass('run');
  }

  play() {
    this.$loop.addClass('run');
  }

  pause() {
    this.$loop.removeClass('run');
  }

  listen() {
    this.$element
      .on('beforeChange', this.beforeChange)
      .on('afterChange', this.afterChange)
      .on('playing', this.play)
      .on('paused', this.pause);
  }
}
